import { api } from "@/services/api"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "vue"
import type { User } from "./sharedTypes"

export const retrieveUser = async (userId: string) => {
  const { body } = await api.get<User>(`/users/${userId}/`)

  return body
}

export const useUser = (userId: MaybeRef<string>) =>
  useQuery({
    queryKey: [USERS_QUERY_KEY, userId] as const,
    queryFn: ({ queryKey: [_, userId_] }) =>
      retrieveUser(userId_),
  })
